import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/react";
export function AppContextProvider(props) {
  var _props$contexts = props.contexts,
      contexts = _props$contexts === void 0 ? [] : _props$contexts,
      children = props.children;
  return ___EmotionJSX(React.Fragment, null, contexts.reduceRight(function (combinedContexts, Context) {
    return ___EmotionJSX(Context, null, combinedContexts);
  }, children));
}